import * as React from 'react'

import { TryInStoreBanner, TryInStoreProvider } from '@grandvisionhq/fun-try-in-store'
import { NextPage } from '@grandvisionhq/next'
import {
  ErrorCase,
  InitialProps,
  Page,
  Props,
} from '@grandvisionhq/www-next/pages/product-detail/sunglasses'
import { FullDateDeliveryIndicatorContainer } from '@grandvisionhq/www-next/slot-components/FullDateDeliveryIndicatorContainer'
import { LoyaltyPointsGraphContainer } from '@grandvisionhq/www-next/slot-components/LoyaltyPointsGraphContainer'
import { RxGlassesConfiguratorGraphContainer } from '@grandvisionhq/www-next/slot-components/RxGlassesConfiguratorGraphContainer'
import { TryInStoreAddButtonGraphContainer } from '@grandvisionhq/www-next/slot-components/TryInStoreAddButtonGraphContainer'

import { composePDP } from '../../../components/hocs/compose-pdp'
import { commonSpecifications, getDeliveryIndicatorConfig } from '../../../configuration'

const slots: Props['slots'] = {
  AfterCTA: TryInStoreAddButtonGraphContainer,
  BeforeUsps: LoyaltyPointsGraphContainer,
  Configurator: RxGlassesConfiguratorGraphContainer,
  DynamicDeliveryIndicator: FullDateDeliveryIndicatorContainer,
  TopBanner: TryInStoreBanner,
}

const ProductDetailPage: NextPage<Props, InitialProps | ErrorCase> = (props) => {
  const deliveryIndicatorConfig = getDeliveryIndicatorConfig()

  return (
    <TryInStoreProvider>
      <Page
        {...props}
        slots={slots}
        deliveryIndicatorConfig={deliveryIndicatorConfig}
        specificationConfiguration={commonSpecifications}
      />
    </TryInStoreProvider>
  )
}

ProductDetailPage.getInitialProps = Page.getInitialProps

export default composePDP<Props>(ProductDetailPage)
